<template>
  <generic-modal :title="$t('profile')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column is-three-fifths">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_is_default"
              v-model="meta.settings.is_default"
            />
            <label for="chk_is_default">{{ $t("is default") }}</label>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("wsdl url") }}</label>
        <p class="control is-expanded has-icons-left">
          <input
            type="text"
            class="input"
            v-model="meta.settings.wsdl_url"
            placeholder="https://info.sib.gob.gt:4443/CarteraWS/webservicesirc?wsdl"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-server"></i>
          </span>
        </p>
      </div>
      <div class="field">
        <label class="label">{{ $t("application key") }}</label>
        <p class="control is-expanded has-icons-left">
          <input
            type="text"
            class="input"
            v-model="meta.settings.application_key"
            placeholder="648571254"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-server"></i>
          </span>
        </p>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("user") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.settings.username"
                placeholder="0200"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("password") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="password"
                class="input"
                v-model="meta.settings.password"
                placeholder="0400"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-lock"></i>
              </span>
            </p>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, get, generate_error_message_text } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ProfileModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: { settings: {} },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.name || !v.meta.settings.username || !v.meta.settings.password
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(profile_uuid) {
      let v = this;
      v.set_initial_state();
      get("/sirc/profile", { uuid: profile_uuid })
        .then((profile) => {
          v.meta = profile;
          console.log("v.meta", v.meta);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let profile = { ...v.meta };
      if (profile.uuid) {
        post("/sirc/profile", profile)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {});
      } else {
        put("/sirc/profile", profile)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {});
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {
          is_default: false,
          password: "",
          username: "",
          wsdl_url: "",
        },
      };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
